import { useState, useEffect } from "react";
import domain from "../../../../reusecomponent/domain";
import { useSelector } from "react-redux";
import { getMedia, getMediafixtid, saveMedia } from "../mediaCache";
import { WorningToastContainer } from "../../../function/CustomFunction";

// ─── ImagePreview ─────────────────────────────────────────────────────────────
// Used inside the chat message bubble.
export function ImagePreview({ chat, sending_type }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const Accesstoken = useSelector((state) => state.Token.value);

  const loadImage = async () => {
    setLoading(true);
    try {
      const fileid = chat.file_id;
      if (!fileid) { setLoading(false); return; }

      const localBlob = await getMedia(chat.body_type, chat.type, fileid);
      if (localBlob.exists) {
        if (localBlob.value == null) { setLoading(false); return; }
        setImageUrl(URL.createObjectURL(localBlob.value));
        setLoading(false);
        return;
      }

      const fileResponse = await fetch(
        `${domain()}/whatsapp/${sending_type}/image/${fileid}`,
        { method: "GET", headers: { Authorization: `Bearer ${Accesstoken}` } }
      );
      if (fileResponse.ok) {
        const blob = await fileResponse.blob();
        await saveMedia(chat.body_type, chat.type, fileid, blob);
        setImageUrl(URL.createObjectURL(blob));
      } else {
        WorningToastContainer("Image not found on server!");
        await saveMedia(chat.body_type, chat.type, fileid, null);
      }
    } catch (_) {
      // Silently fail
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadImage();
    return () => { if (imageUrl) URL.revokeObjectURL(imageUrl); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat.file_id]);

  return (
    <div style={{ width: "200px", borderRadius: "10px", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            width: "200px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#eaeaea",
            borderRadius: "10px",
          }}
        >
          <div className="spinner-border spinner-border-sm text-secondary" role="status">
            <span className="visually-hidden">Loading image…</span>
          </div>
        </div>
      ) : (
        <img
          src={imageUrl}
          alt="chat media"
          style={{ width: "100%", height: "auto", cursor: "pointer", borderRadius: "10px" }}
        />
      )}
    </div>
  );
}

// ─── ImagePreviews ────────────────────────────────────────────────────────────
// Used inside the MediaTabs panel (compact thumbnail, cache-only).
export function ImagePreviews({ chat }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadImage = async () => {
    setLoading(true);
    try {
      const fileid = chat.file_id;
      if (!fileid) { setLoading(false); return; }

      // FIXED: was `sstyle` (no-op prop) — styles now applied correctly
      const localBlob = await getMediafixtid(chat.body_type, fileid);
      if (localBlob.exists) {
        if (localBlob.value == null) { setLoading(false); return; }
        setImageUrl(URL.createObjectURL(localBlob.value));
      }
    } catch (_) {
      // Silently fail
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadImage();
    return () => { if (imageUrl) URL.revokeObjectURL(imageUrl); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat.file_id]);

  // FIXED: was `sstyle` (typo), now correct `style`
  return (
    <div style={{ aspectRatio: "1 / 1", height: "100px", overflow: "hidden", borderRadius: "8px", background: "#eaeaea" }}>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="spinner-border spinner-border-sm text-secondary" role="status">
            <span className="visually-hidden">Loading…</span>
          </div>
        </div>
      ) : (
        <img
          src={imageUrl}
          alt="media thumbnail"
          style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" }}
        />
      )}
    </div>
  );
}